import styled from 'styled-components';

export const HorizontalCenter = styled.div`
  display: flex;
  justify-content: center;
`;
export const VerticalCenter = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
`;

export const FlexBox = styled.div`
  display: flex;
`;
